var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"display":"none","border":"1px solid","width":"100%","height":"100%","margin":"5px 0","position":"relative"},attrs:{"id":"wrap"}})])
}]

export { render, staticRenderFns }